import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from 'store';
import MainTheme from 'components/themes/main';


//
import { fetchApplication, fetchApplicationLocales, fetchApplicationCharts, fetchBodyHeightUnits, fetchBodyWeightUnits } from 'actions'

if (process.env.NODE_ENV === 'production') console.log = function () {};

// const store = Store()

store.dispatch(fetchApplication(process.env.REACT_APP_NAME))
store.dispatch(fetchApplicationLocales(process.env.REACT_APP_NAME))
store.dispatch(fetchApplicationCharts(process.env.REACT_APP_NAME))
store.dispatch(fetchBodyHeightUnits())
store.dispatch(fetchBodyWeightUnits())

ReactDOM.render(
    <Provider store={store}>
        <MainTheme>
            <App/>
        </MainTheme>
    </Provider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
